<template>
  <div class="flex min-h-screen flex-col bg-brand-chalk">
    <SfgTextureDefs/>
    <SfgHeader/>
    <main class="flex-1">
      <slot/>
    </main>
    <SfgFooter/>
    <AboutModal/>
  </div>
</template>
